<template>
    <NuxtLayout name="default" mainClass="inside_main">
        <template v-if="place">
            <!-- Breadcrumb -->

            <div class="main-catgories-wrapper">
                <Breadcrumb :is-container="true" :paths="breadcrumbPaths" />
                <!-- Profile Section -->
                <div class="main-profile container">
                    <PlaceProfile :place="place" :avatar-url="place?.main_image" @review-added="fetchReviews(1)"
                        :cleaned-store-link="cleanedStoreLink" />
                </div>
            </div>


            <!-- Gallery Section (only if there are images) -->
            <PlaceGallery :place="place" />

            <!-- Comments Section -->
            <PlaceComments :place="place" :rates="ratings" :filterText="filterSearchInput" :loadMore="loadMoreReviews" :setSort="setSortRatings"
                :loading="ratingsLoading" :nextPage="ratingsPage" />

            <!-- Suggested Places Section -->
            <SuggestedPlaces :places="places" :loadMore="loadMorePlaces" :nextPage="placesPage"
                :loading="placesLoading" />



            <div class="modal bottomSheet userModels FilterRateModal" id="filter_rate_modal" tabindex="-1"
                aria-labelledby="filterModalLabel" aria-hidden="true">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <!-- Modal Header -->
                        <div class="modal-header pb-0">

                        </div>
                        <!-- Modal Body -->
                        <div class="modal-body pt-3">
                            <form @submit.prevent="submitFilter">
                                <div class="filter-rate-wrapper">
                                    <div class="filter-head-title">
                                        <h5 class="filter-title">فلترة التقييمات</h5>
                                        <button @click="resetFilter" type="button" class="reset-filter">مسح الفلتر</button>
                                    </div>
                                    <div class="filter-body">
                                        <div class="part">
                                            <p class="filter_label">
                                                ترتيب حسب
                                            </p>
                                            <div class="radio-input">
                                                <label class="label">
                                                    <input type="radio" id="latest" v-model="filterOrder" 
                                                        name="value-radio" value="3">
                                                    <p class="text">الأحدث</p>
                                                </label>

                                                <label class="label">
                                                    <input type="radio" id="highest" v-model="filterOrder"
                                                        name="value-radio" value="1">
                                                    <p class="text">الأعلى</p>
                                                </label>

                                                <label class="label">
                                                    <input type="radio" id="lowest" v-model="filterOrder"
                                                        name="value-radio" value="4">
                                                    <p class="text">الأقل</p>
                                                </label>

                                                <label class="label">
                                                    <input type="radio" id="most-liked" v-model="filterOrder"
                                                        name="value-radio" value="2">
                                                    <p class="text">الأكثر إعجاباً</p>
                                                </label>
                                            </div>
                                        </div>
                                        <div class="part">
                                            <p class="filter_label">
                                                تقييم يحتوي على كلمة
                                            </p>

                                            <div class="search_input">
                                                <input class="searchInput" type="text" v-model="filterSearchInput"
                                                    name="q" id="qM" autocomplete="off" placeholder="بحث">
                                                <button class="searchButton" type="button">
                                                    <svg id="vuesax_linear_search-normal"
                                                        data-name="vuesax/linear/search-normal"
                                                        xmlns="http://www.w3.org/2000/svg" width="21.029"
                                                        height="21.029" viewBox="0 0 21.029 21.029">
                                                        <g id="search-normal">
                                                            <path id="Vector"
                                                                d="M16.648,8.324A8.324,8.324,0,1,1,8.324,0,8.324,8.324,0,0,1,16.648,8.324Z"
                                                                transform="translate(1.752 1.752)" fill="none"
                                                                stroke="#d0d5dc" stroke-linecap="round"
                                                                stroke-linejoin="round" stroke-width="1.7" />
                                                            <path id="Vector-2" data-name="Vector" d="M1.752,1.752,0,0"
                                                                transform="translate(17.524 17.524)" fill="none"
                                                                stroke="#d0d5dc" stroke-linecap="round"
                                                                stroke-linejoin="round" stroke-width="1.7" />
                                                            <path id="Vector-3" data-name="Vector"
                                                                d="M0,0H21.029V21.029H0Z" fill="none" opacity="0" />
                                                        </g>
                                                    </svg>
                                                </button>
                                            </div>
                                        </div>
                                        <button id="saveFilterButton" type="submit"
                                            class="filterSaveBtn has-spinner-link">
                                            <div class="button_text">عرض</div>
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <!-- End Modal Body -->
                    </div>
                </div>
            </div>
        </template>
    </NuxtLayout>
</template>

<script setup lang="ts">

import { useHead } from '#imports';
import { onMounted } from 'vue';



import {
    ref,
    computed,
    shallowRef
} from 'vue';
import {
    useRoute
} from 'vue-router';
import type {
    Place,
    Rating
} from '~/types/types';

// Nuxt 3 API injection
const {
    $api
} = useNuxtApp();

// Repositories
const placeRepo = placesRepository();
const ratingRepo = ratingsRepository();

// Get the place ID from the route
const route = useRoute();
const placeId = computed(() => route.params.place_id as string);

// Reactive state
// const place = shallowRef<Place | null>(null); // Use shallowRef for better performance
const placeData = shallowRef<Place | null>(null); // Use shallowRef for better performance
const places = ref<Place[]>([]);
const ratings = ref<Rating[]>([]);
const ratingsPage = ref<number | null>(null);
const ratingsLoading = ref<Boolean>(true);
const placesPage = ref<number | null>(null);
const placesLoading = ref<Boolean>(true);
const filterOrder = ref(null)
const filterSearchInput = ref(null)
const filterSearchText = ref(null)


onMounted(async () => {
    try {
        fetchReviews(1);
        fetchPlaces(1);
    } catch (error) {
        console.error('Error fetching place details:', error)
    }
})



      

const { data: place, error } = await useAsyncData(`place-${placeId.value}`, () =>
    placesRepository().showById(placeId.value), {
    lazy: false, // يجبر SSR على جلب البيانات عند تحميل الصفحة
}
);

if (error.value) {

    console.error('useAsyncData Error:', error.value);
    // navigateTo('/wrong', { redirectCode: 404 });

}
const currentUrl = import.meta.client ? window.location.href : useRequestURL().href;


const slugify = (text: string): string =>
    text ? text.trim().replace(/\s+/g, '-').toLowerCase() : ''

if (place.value) {


           // Get the cookie named 'visitedPlaceIds'. Default to an empty array if not set.
      // The useCookie composable automatically handles getting and setting the value.
      const visitedPlaceIds = useCookie<string[]>('visitedPlaceIds', { default: () => [] });
      // Retrieve the current list of IDs from the cookie.
      let ids = visitedPlaceIds.value || [];

      // Check if the current ID is already in the cookie.
      if (!ids.includes(place.value.id)) {
        // Remove the oldest ID if there are already 10 IDs stored.
        if (ids.length >= 10) {
          ids.shift(); // Remove the first (oldest) element
        }
        // Add the new ID.
        ids.push(place.value.id);
        // Update the cookie value.
        visitedPlaceIds.value = ids;
      }

    const ogTitle = place.value?.meta_title ? `${place.value?.meta_title}` : `${place.value?.name}`

    const ogDescription = (place.value?.meta_des ? place.value?.meta_des : `${place.value?.description ? place.value?.description?.substring(0, 300) : ''}...`) + ' | منصة رفيو توفر للمستخدمين الاطلاع على تقييمات و مراجعات لمنتجات و مطاعم و خدمات بكل شفافية و جودة عالية من تجارب حقيقية مما يساعد المستخدمين في اتخاذ قرارات شراء مدروسة بناءً على آراء موثوقة'

    useHead({
        link: [
            {
                rel: 'canonical',
                // Using window.location.href ensures the current URL is set as canonical.
                href: currentUrl
            }
        ],
        title: `${place.value.name}`,
        meta: [
            {
                name: 'title',
                content: ogTitle
            },
            {
                name: 'description',
                content: ogDescription
            },
            // Open Graph / Facebook
            { property: 'og:title', content: ogTitle },
            { property: 'og:description', content: ogDescription },
            { property: 'og:image', content: place.value?.main_image ?? '/website/assets/img/logo/review-logo.png' },
            // Twitter
            { property: 'twitter:title', content: ogTitle },
            { property: 'twitter:description', content: ogDescription },
            { name: 'twitter:image', content: place.value?.main_image ?? '/website/assets/img/logo/review-logo.png' },
        ],


        script: [
            {
                type: 'application/ld+json',
                innerHTML: JSON.stringify({
                    "@context": "https://schema.org",
                    "@type": "FoodEstablishment",
                    "aggregateRating": {
                        "@type": "AggregateRating",
                        "ratingValue": place.value.total_rate_db ? Number(place.value.total_rate_db).toFixed(1) : "0.0",
                        "reviewCount": place.value.rates_count_db ?? 0
                    },
                    "address": {
                        "@type": "PostalAddress",
                        "addressCountry": {
                            "@type": "Country",
                            "name": "SA"
                        },
                        "streetAddress": "طريق الثوما",
                        "addressLocality": "الرياض",
                        "postalCode": "11372"
                    },
                    "name": place.value.name,
                    "image": place.value.main_image,
                    "priceRange": "$",
                    "url": currentUrl
                })
            },
            {
                type: 'application/ld+json',
                innerHTML: JSON.stringify({
                    "@context": "https://schema.org/",
                    "@type": "BreadcrumbList",
                    "itemListElement": [
                        {
                            "@type": "ListItem",
                            "position": 1,
                            "name": "الرئيسية",
                            "item": "https://reviewapp.sa//"  // Adjust if you have a specific home route
                        },
                        {
                            "@type": "ListItem",
                            "position": 2,
                            "name": place.value.categories && place.value.categories.length
                                ? place.value.categories[0].name
                                : 'الرئيسية',
                            "item": place.value.categories && place.value.categories.length
                                ? `https://reviewapp.sa/category/${place.value.categories[0].id}/${slugify(place.value.categories[0].name)}`
                                : 'https://reviewapp.sa/'
                        },
                        {
                            "@type": "ListItem",
                            "position": 3,
                            "name": place.value.name,
                            "item": currentUrl
                        }
                    ]
                })
            }
        ]
    });
}



/**
 * Fetch reviews with pagination
 */
const fetchReviews = async (page = 1) => {
    try {
        const {
            data: reviewsData,
            nextPage: reviewsNextPage
        } = await ratingRepo.get({
            place_id: place.value.id,
            sort: filterOrder.value ?? '1',
            review: filterSearchInput.value ?? null
        },
            page
        );
        ratings.value = page === 1 ? reviewsData : [...ratings.value, ...reviewsData];
        ratingsPage.value = reviewsNextPage;
        filterSearchText.value = filterSearchInput.value ?? null;
        ratingsLoading.value = false;
    } catch (error) {
        console.error("Error fetching reviews:", error);
    }
};

/**
 * Fetch places with pagination
 */
const fetchPlaces = async (page = 1) => {
    try {
        const {
            data: placesData,
            nextPage: placesNextPage
        } = await placeRepo.get({
            without_place_id: place.value.id,
            page_count: 8
        },
            page
        );
        places.value = page === 1 ? placesData : [...places.value, ...placesData];
        placesPage.value = placesNextPage;
        placesLoading.value = false;
    } catch (error) {
        console.error("Error fetching places:", error);
    }
};

// Load more reviews when needed
const loadMoreReviews = async () => {
    ratingsLoading.value = true;
    if (ratingsPage.value) await fetchReviews(ratingsPage.value);
};


const loadMorePlaces = async () => {
    placesLoading.value = true;
    if (placesPage.value) await fetchPlaces(placesPage.value);
};


/**
 * Set a new filter order and re-fetch ratings.
 * @param {string} order - One of "top-rated", "most-rated", or "recent-rated".
 */
const setSortRatings = async (order: string) => {
    ratingsPage.value = 1;
    ratings.value = [];

    await loadMoreReviews()
}
const {
          closeModal
      } = useBootstrapModal("filter_rate_modal");


      
/**
 * Handle the reset filter button.
 * Resets the filter to default values, clears the search input,
 * refreshes the reviews with default filter and closes the modal.
 */
const resetFilter = async () => {
  // Reset filter selections to default values (adjust as needed)
  filterOrder.value = null           // Reset to default value "latest"
  filterSearchInput.value = null      // Clear the search input

  // Reset the reviews list and load the default reviews.
  ratingsPage.value = 1
  ratings.value = []
  await loadMoreReviews()

  // Optionally, you might want to close the modal here as well.
  closeModal()
}

/**
 * Handle form submission by setting the filter order.
 * The filtering logic could be extended to include search parameters
 * or additional business logic.
 */
const submitFilter = async (e: Event) => {
    ratingsLoading.value = true;

    ratingsPage.value = 1;
    ratings.value = [];

    await loadMoreReviews()

    ratingsLoading.value = false;
    
    closeModal()
}

// watch(place, (newPlace, oldPlace) => {
//     if (newPlace && newPlace !== oldPlace) {
//         fetchReviews(1);
//         fetchPlaces(1);
//     }
// });

/**
 * Clean the store link to remove unnecessary parts (e.g., https:// or www.)
 */
const cleanedStoreLink = computed(() => {
    return place.value?.store_link?.replace(/(https?:\/\/(www\.)?|www\.)/, '') || '';
});




const breadcrumbPaths = computed(() => {
    const paths = [];
    if (place.value) {
        // If place.categories exists and is not empty, add the first category breadcrumb.
        if (place.value.categories && place.value.categories.length > 0) {
            const category = place.value.categories[0];
            paths.push({
                label: category.name,
                link: `/category/${category.id}/${slugify(category.name)}`
            });
        }
        // Add the place name as the last breadcrumb.
        paths.push({
            label: place.value.name,
            link: ''
        });
    }
    return paths;
});




useHead({
    // title: 'رفيو', // Use computed property to ensure reactivity
    // meta: [{
    //     name: 'description',
    //     content: ' منصة رفيو توفر للمستخدمين الاطلاع على تقييمات و مراجعات لمنتجات و مطاعم و خدمات بكل شفافية و جودة عالية من تجارب حقيقية مما يساعد المستخدمين في اتخاذ قرارات شراء مدروسة بناءً على آراء موثوقة'
    // }],
    style: [
        {
            children: `
                .main.inside_main {
                    background: #f9f9f9;
                }
                .main.inside_main {
                   padding-top: 0 !important;
                }

                header.main-header:has(+ .inside_main) {
                    background-image: none;
                }

                .latest_comments:has(~ .place_gallery_wrapper) {
                            padding-top: 40px;
                        }
                .main .place_gallery_wrapper+.latest_comments {
                    padding-top: 30px;
                }

                .breadcrumb_wrapper {
                    position: relative;
                    top: 115px;
                }

                #latest_comments_wrap {
                    scroll-margin-top: 70px;
                }

                @media(max-width: 767px) {

                .main.inside_main {
                           background-size: 0 !important;
                }

                    .main-catgories-wrapper {
                        padding-top: 130px;
                    }

                    .latest_comments {
                        padding-top: 80px;
                    }

                }

                @media(max-width: 576px) {
                    .main-catgories-wrapper {
                        padding-top: 35px !important;
                    }

                    .breadcrumb_wrapper {
                        position: relative;
                        top: 60px;
                    }
                }
            `
        }
    ]
});
</script>
